import React, { FC } from 'react';
import clsx from 'clsx';

export interface SkeletonProps extends React.CSSProperties {
    className?: HTMLElement['className'];
    testId?: string;
}

/** Skeleton Component: just a `<div />` with `gx-skeleton` className; any other classnames or inline css style can be passed. */
export const Skeleton: FC<SkeletonProps> = ({
    className,
    testId,
    ...style
}) => (
    <div
        className={clsx(['gx-skeleton', className])}
        style={style}
        data-testid={testId}
    />
);
